export const MAX_ALLOWED_LEVEL = 4;
export const BACKEND_NAME_SEPARATOR = '&&&';
export const NAME_SEPARATOR = ',';
export const CONFIG_LOGS = 'config-logs';
export const LOG_TABLE_TITLE = 'Change Logs';
export const ADD_SEPARATOR = ' + ';
